import HCLDX from "@system/config/hcldx";
import $ from "jquery";
import System from "src/helper/system";

class Product {
    static PRODUCT_INVENTORY_AVNET = System.getInventoryUrl() + '/api/inventory/amer/getinventory';
    static PRODUCT_INVENTORY_NEWARC = System.getInventoryUrl() + '/api/inventory/amer/getNewarkStocksDetails';
    static PRODUCT_PRICING = System.getPriceUrl() + '/api/pricing/getprice';
    static PRODUCT_PRICING_NEW = System.getPriceUrl() + '/api/pricing/getprices';
    static PRODUCT_LISTING = System.getApplicationUrl() + '/api/application/product/search';
    static PRODUCT_LISTING_FACETS = System.getApplicationUrl() + '/api/application/FacetsSearch';
    static PRODUCT_GROUPED_LISTING = System.getApplicationUrl() + '/api/application/product/manual/search';
    static PRODUCT_CATEGORY_LIST = System.getApplicationUrl() + '/api/application/product/category';
    static PRODUCT_LISTING_AZURE_SERVICE = 'https://fsp-global-product-keyword-dev.search.windows.net/indexes/productlisting/docs/search?api-version=2020-06-30-Preview';
    static PRODUCT_LISTING_SEND_MAIL = System.getProductUrl() + '/api/product/sendMail';
    static PRODUCT_DOCUMENT_LIST = System.getApplicationUrl() + '/api/application/product/documentsearch'
    static PRODUCT_VARIANT_ASSET_LIST = System.getApplicationUrl() + '/api/application/variantasset/search'
    static PRODUCT_ALTERNATIVE_DATA_LIST = System.getApplicationUrl() + '/api/application/product/subalternative'
    static GET_DESIGN_DATA = System.getBOMUrl() + '/api/designhub/getdesigns'
    static CHECK_DESIGNS_EXIST = System.getBOMUrl() + '/api/designhub/checkdesigns'
    static PRODUCT_REPORT_ERROR = System.getProductUrl() + '/api/product/reportError'
    static PRODUCT_MANUFACTURE_EXTERNAL_SEARCH = System.getApplicationUrl() + '/api/application/product/urlCategoryManufacturerInfo'
    static UNIVERSAL_PRODUCT_SEARCH = System.getApplicationUrl() + '/api/application/product/auto/search'
    static UNIVERSAL_MANUFACTURERS_CATEGORY_SEARCH = System.getApplicationUrl() + '/api/application/product/auto/category/manufacturer'
    static PRODUCT_PRICING_LIST = System.getPriceUrl() + '/api/pricing/amer/getWebResalePricing'
    static CURRENCY_CONVERSION = System.getPriceUrl() + '/api/pricing/amer/currencyConversion';
    static PRODUCT_MANUFACTURE_EXTERNAL_HEADING = System.getApplicationUrl() + '/api/application/product/categoryNameDescAndImage';
    static product__ROHSCompliantCode(value) {
        const c = {
            "Y": "RoHS 6 Compliant",
            "X": "RoHS 6 Exempt",
            "N": "RoHS Non Complaint",
            "U": "UNDETERMINED",
            "C": "RoHS 10 Compliant",
            "E": "RoHS 10 Exempt",
        }
        if (c[value] !== undefined) {
            return c[value];
        }
        return value;
    }

    static getProductListingPageRouteURL(c = {}) {
        if (Object.entries(c).length > 0) {
            return HCLDX.baseURL() + '/products/c/search?' + $.param(c);
        }
        return HCLDX.baseURL() + '/products/c/search';
    }

    static getProductListingNotFoundPageRouteURL() {
        return HCLDX.baseURL() + '/shop/part-not-found';
    }

    static getProductDetailPageRouteURL() {
        return HCLDX.baseURL() + '/product/:ManufacturerName/:ERPMFRPartNumber/:ItemNumber';
    }

}

export default Product;